import { combineReducers } from 'redux';

import basicState, { basicInitialState } from './basic';
import builderState, { builderInitialState } from './builder';
import resultsState, { resultsInitialState } from './results';
import saveDialogState, { saveDialogInitialState } from './saveDialog';

export const creatorInitialState =  { 
  basicState: basicInitialState,
  builderState: builderInitialState,
  resultsState: resultsInitialState,
  saveDialogState: saveDialogInitialState
}

export default combineReducers({ 
  basicState,
  builderState,
  resultsState,
  saveDialogState
})